<template>
  <div v-if="visible">
    <div class="chartPhoto" :style="{width:width,height:height}">
       <span class="layout_head">{{ headText }}</span>
       <div class="layout_content">
          <slot></slot>
       </div>
       <div class="layout_control" v-if="showControl">
          <a-button class="btn_quxiao" @click="cancle">取消</a-button>
          <a-button class="btn_ok btn" @click="sure">确定</a-button>
       </div>
        <img src="@/style/img/关闭.png" class="close" @click="cancle">
        <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
        <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
        <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
        <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
    </div>
    <div class="chart_bg" ></div>
  </div>

</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
      width: {
          default: "50%",
          type: String,
      },
      height: {
          default: "50%",
          type: String,
      },
      headText:{
        default:'标题',
        type: String,
      },
      visible:{
        default:false,
        type: Boolean,
      },
      showControl:{
        default:false,
        type:Boolean
      }
    },
    methods: {
      cancle() {
        this.$emit('cancleOperate')
      },
      sure() {
        this.$emit('sureOperate')
      }
    }
}
</script>

<style>
.chartPhoto {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: linear-gradient(#15273f 0%, #1d3c52 100%);
  border: 1px solid #2b76a1;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart_bg {
  position: absolute;
  top:0;
  left: 0;
  width:100%;
  height:100%;
  background-color:#1f1f1f79;
  z-index: 10;
}
.close {
    position: absolute;
    top: 0;
    right:0;
    transform :translate(50%,-50%);
    z-index: 200;
    width: 2.4vw;
  }
  .info_lt,.info_rb,.info_rt,.info_lb{
      position:absolute;
      z-index: 100;
  }
  .info_lt {
      top: 1px;
      left: 1px;
  }
  .info_rb {
      bottom: 1px;
      right: 1px;
  }
   .info_rt{
      top: 1px;
      right: 1px;
  }
  .info_lb {
      bottom: 1px;
      left: 1px;
  }
  .layout_head {
    background-position: center;
    height: 42px;
    font-size: 1vw;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .layout_content {
    flex: 1;
    width: 100%;
    /* display: flex; */
    /* align-items: center;
    justify-content: center; */
  }
  .layout_control {
    margin-bottom : 10px
  }
  .btn {
    margin-right:10px;
    font-size: 16px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400; 
    line-height: 14px;
    background: linear-gradient(-45deg,#0c96b1 0%, #0fbca1 100%);
    border: 1px solid;
    border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  }
  .btn_quxiao,.btn_quxiao:hover,.btn_quxiao:focus {
    margin-right:24px;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400; 
    line-height: 14px;
    background: transparent;
    border: 1px solid;
    border-image: linear-gradient(0deg, #0eb4dd 0%, #01efbc 100%) 1 1;
    padding : 4px 24px
  }
  .btn_ok {
    padding : 4px 24px
  }
</style>
